import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfFont,
  PdfBrush,
  PdfColor,
  ETextAlign,
  PageGen,
} from '../../pdf/pdf';
import { ILayoutLabelTextGen } from '../layoutLabelText';
import { OptsLabelText } from '../optsLabelText';
import { GUtil } from '../../pdf/gutil';
import { IItemCount } from '@educraft/base';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/label';
import '../../pdf/draw/cut';

/**
 * Inicialy__2 - Uppercase/lowercase initial letter
 *
 * Layout: Multiple portrait pages, 2×5 grid per page.
 * Each cell: image on left square, colored square with "A a" text on right.
 *
 * Migrated from C# EduFrame.Img10.Generators.Inicialy__2
 */
export class Inicialy__2 implements ILayoutLabelTextGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const itemsPerPage = 10;
    const pagesNeeded = Math.ceil(opts.list.length / itemsPerPage);
    const pages: PageGen[] = [];
    for (let i = 0; i < pagesNeeded; i++) {
      pages.push(pdf.addPage());
    }

    const margin = PdfUnit.FromMillimeters(5);
    const cellWidth = (PdfSize.A4.width - 2 * margin) / 2;
    const cellHeight = (PdfSize.A4.width - 2 * margin) / 4;

    const palettes: string[][] = [
      [
        '#7cbfc3',
        '#93c6b1',
        '#a8cc9d',
        '#bdd286',
        '#d1d769',
        '#e0d258',
        '#e8c35a',
        '#f0b45b',
        '#f6a45d',
        '#fb945d',
      ],
      [
        '#b67cc4',
        '#a593c6',
        '#9eb6cc',
        '#87d2d2',
        '#6bd7c0',
        '#5ae0ae',
        '#5ce89d',
        '#5df08c',
        '#5ff67b',
        '#5ffb6b',
      ],
      [
        '#f3da7c',
        '#f1cd89',
        '#eec194',
        '#ebb49e',
        '#e9a7a6',
        '#e699ae',
        '#e38bb4',
        '#df7cbb',
        '#dc6dc0',
        '#d85bc5',
      ],
      [
        '#4f839f',
        '#899cbf',
        '#c0b6e1',
        '#eac9fb',
        '#aeaed8',
        '#7293b6',
        '#2b7795',
        '#568f84',
        '#8aab6d',
        '#bec73f',
      ],
      [
        '#63776a',
        '#8daf61',
        '#bae93b',
        '#b2df5b',
        '#8bac82',
        '#687993',
        '#4c4199',
        '#422493',
        '#4b4d82',
        '#586a6d',
      ],
    ];

    const colors = GUtil.randomBrushes(opts.data.random, palettes);
    const font = new PdfFont(PdfFont.FONT_NAME, 60);

    for (let pageIndex = 0; pageIndex < pagesNeeded; pageIndex++) {
      const page = pages[pageIndex];
      const pageStartIndex = pageIndex * itemsPerPage;

      for (let x = 0; x < 2; x++) {
        for (let y = 0; y < 5; y++) {
          const index = pageStartIndex + x * 5 + y;
          if (index >= opts.list.length) continue;

          const rect = new PdfRect(
            margin + x * cellWidth,
            margin + y * cellHeight,
            cellWidth,
            cellHeight
          );
          const r1 = new PdfRect(rect.x, rect.y, rect.height, rect.height);
          const r2 = new PdfRect(r1.right, rect.y, r1.width, r1.height);

          page.drawLabel(opts.list[index].label, { rect: r1 });

          page.drawRectangle(null, colors[x * 5 + y], r2);
          const ini = opts.list[index].text.substring(0, 1);
          page.drawString(
            `${ini.toUpperCase()} ${ini.toLowerCase()}`,
            font,
            PdfBrush.White,
            null,
            r2,
            ETextAlign.Center
          );
          page.drawRectangle(GUtil.cutPen, null, rect);
        }
      }
    }
  }
}
